import React from 'react';
import SolutionContractCompleteContainer from 'containers/SolutionContractCompleteContainer'

export default function SolutionContractCompletePage() {
  return (
    <SolutionContractCompleteContainer />
  )
}
